import { PLANS } from 'constants/plans'
import {
  UPGRADE_CUSTOM_DOMAIN,
  UPGRADE_ANALYTICS_PAYLOAD,
  UPGRADE_CAPTURE_EMAILS_PAYLOAD,
  UPGRADE_QR_PAYLOAD,
  UPGRADE_EDIT_CODE_PAYLOAD,
  UPGRADE_PASSWORD_PROTECT_PAYLOAD,
  UPGRADE_FEEDBACK_PAYLOAD,
  UPGRADE_TRACKLINKS_PAYLOAD,
  UPGRADE_SLIDE_IN_PAYLOAD
} from 'actions'

export const FEATURE_IDS = {
  CUSTOM_DOMAIN: 'custom_domain',
  ANALYTICS: 'analytics',
  CAPTURE_EMAILS: 'capture_emails',
  QR_CODE: 'qr_code',
  EDIT_CODE: 'edit_code',
  VSCODE_PLUGIN: 'vscode_plugin',
  CHATGPT_APP: 'chatgpt_app',
  PASSWORD_PROTECTION: 'password_protection',
  FEEDBACK_MODE: 'feedback_mode',
  ARCHIVE: 'archive',
  TRACKED_SHARING: 'tracked_sharing',
  LEAD_CAPTURE_SLIDE_IN: 'lead_capture_slide_in'
}

export const categoryFeatures = {
  business_portfolio: [FEATURE_IDS.TRACKED_SHARING, FEATURE_IDS.ANALYTICS, FEATURE_IDS.LEAD_CAPTURE_SLIDE_IN],
  product_portfolio: [FEATURE_IDS.CUSTOM_DOMAIN, FEATURE_IDS.ANALYTICS, FEATURE_IDS.CAPTURE_EMAILS],
  landing_pages: [FEATURE_IDS.ANALYTICS, FEATURE_IDS.CUSTOM_DOMAIN, FEATURE_IDS.LEAD_CAPTURE_SLIDE_IN],
  educational_content: [FEATURE_IDS.CAPTURE_EMAILS, FEATURE_IDS.PASSWORD_PROTECTION, FEATURE_IDS.QR_CODE],
  brochure: [FEATURE_IDS.CUSTOM_DOMAIN, FEATURE_IDS.ANALYTICS, FEATURE_IDS.CAPTURE_EMAILS],
  catalog: [FEATURE_IDS.CUSTOM_DOMAIN, FEATURE_IDS.ANALYTICS, FEATURE_IDS.CAPTURE_EMAILS],
  support_guide: [FEATURE_IDS.QR_CODE, FEATURE_IDS.CAPTURE_EMAILS],
  event_page: [FEATURE_IDS.CAPTURE_EMAILS, FEATURE_IDS.ANALYTICS],
  newsletter: [FEATURE_IDS.FEEDBACK_MODE, FEATURE_IDS.ARCHIVE, FEATURE_IDS.QR_CODE],
  menu: [FEATURE_IDS.QR_CODE],
  report: [FEATURE_IDS.PASSWORD_PROTECTION, FEATURE_IDS.CAPTURE_EMAILS, FEATURE_IDS.ANALYTICS],
  real_estate_materials: [FEATURE_IDS.CAPTURE_EMAILS, FEATURE_IDS.CUSTOM_DOMAIN, FEATURE_IDS.QR_CODE],
  personal_portfolio: [FEATURE_IDS.CUSTOM_DOMAIN, FEATURE_IDS.FEEDBACK_MODE, FEATURE_IDS.ANALYTICS],
  resume: [FEATURE_IDS.ANALYTICS, FEATURE_IDS.CUSTOM_DOMAIN],
  beginner_web_projects: [FEATURE_IDS.EDIT_CODE, FEATURE_IDS.CHATGPT_APP, FEATURE_IDS.VSCODE_PLUGIN]
}

export const featureDetails = {
  [FEATURE_IDS.CUSTOM_DOMAIN]: {
    id: FEATURE_IDS.CUSTOM_DOMAIN,
    title: 'Connect Custom domain',
    description: 'Look professional with your own domain name instead of a generic link.',
    url: '',
    icon: '/assets/icons/custom-domain.svg',
    plan: PLANS.PRO.id,
    payload: UPGRADE_CUSTOM_DOMAIN
  },
  [FEATURE_IDS.ANALYTICS]: {
    id: FEATURE_IDS.ANALYTICS,
    title: 'View Analytics',
    description: "Understand who's visiting your project.",
    url: 'https://helpdesk.tiiny.host/en/article/how-to-add-analytics-to-your-website-easy-ju9he7/',
    icon: '/assets/icons/chart-bar.svg',
    plan: PLANS.TINY.id,
    payload: UPGRADE_ANALYTICS_PAYLOAD
  },
  [FEATURE_IDS.CAPTURE_EMAILS]: {
    id: FEATURE_IDS.CAPTURE_EMAILS,
    title: 'Enable Email Capture',
    description: 'Turn anonymous visitors into leads.',
    url: '',
    icon: '/assets/icons/mail.svg',
    plan: PLANS.PRO_U.id,
    payload: UPGRADE_CAPTURE_EMAILS_PAYLOAD
  },
  [FEATURE_IDS.QR_CODE]: {
    id: FEATURE_IDS.QR_CODE,
    title: 'Generate QR Code',
    description: 'The simplest way to share your link, offline and online.',
    url: 'https://helpdesk.tiiny.host/en/article/turn-your-pdf-into-a-qr-code-in-seconds-wklk8n/',
    icon: '/assets/icons/qr-code.svg',
    plan: PLANS.TINY.id,
    payload: UPGRADE_QR_PAYLOAD
  },
  [FEATURE_IDS.EDIT_CODE]: {
    id: FEATURE_IDS.EDIT_CODE,
    title: 'Edit HTML/CSS/JS',
    description: 'Make quick make changes online.',
    url: '',
    icon: '/assets/icons/edit.svg',
    plan: PLANS.PRO.id,
    payload: UPGRADE_EDIT_CODE_PAYLOAD
  },
  [FEATURE_IDS.VSCODE_PLUGIN]: {
    id: FEATURE_IDS.VSCODE_PLUGIN,
    title: 'Download VSCode plugin',
    description: 'Deploy straight from your code editor - no extra steps.',
    url: 'https://marketplace.visualstudio.com/items?itemName=TiinyHost.tiinyhost',
    icon: '/assets/icons/vs-code.png'
  },
  [FEATURE_IDS.CHATGPT_APP]: {
    id: FEATURE_IDS.CHATGPT_APP,
    title: 'Build With ChatGPT App',
    description: 'Build and host a website in one go using AI.',
    url: 'https://chatgpt.com/g/g-6731c3a9f8a48190b445f7d2c8d4f817-instant-app-website-generator-by-tiinyhost',
    icon: '/assets/icons/openai.svg'
  },
  [FEATURE_IDS.PASSWORD_PROTECTION]: {
    id: FEATURE_IDS.PASSWORD_PROTECTION,
    title: 'Enable Password Protection',
    description: 'Keep your project private and confidential.',
    url: '',
    icon: '/assets/icons/lock-black.svg',
    plan: PLANS.PRO.id,
    payload: UPGRADE_PASSWORD_PROTECT_PAYLOAD
  },
  [FEATURE_IDS.FEEDBACK_MODE]: {
    id: FEATURE_IDS.FEEDBACK_MODE,
    title: 'Enable Comments',
    description: 'Gather feedback on your project.',
    url: '',
    icon: '/assets/icons/feedback-comment.svg',
    plan: PLANS.PRO_U.id,
    payload: UPGRADE_FEEDBACK_PAYLOAD
  },
  [FEATURE_IDS.ARCHIVE]: {
    id: FEATURE_IDS.ARCHIVE,
    title: 'Archive',
    description: 'Hide old projects but keep them ready to bring back anytime.',
    url: 'https://helpdesk.tiiny.host/en/article/how-to-archive-your-projects-cd4ftr/?bust=1744972604227',
    icon: '/assets/icons/archive-box.svg'
  },
  [FEATURE_IDS.TRACKED_SHARING]: {
    id: FEATURE_IDS.TRACKED_SHARING,
    title: 'Create A Tracked Link',
    description: 'See who clicked your links and when they did it.',
    url: '',
    icon: '/assets/icons/share.svg',
    plan: PLANS.PRO.id,
    payload: UPGRADE_TRACKLINKS_PAYLOAD
  },
  [FEATURE_IDS.LEAD_CAPTURE_SLIDE_IN]: {
    id: FEATURE_IDS.LEAD_CAPTURE_SLIDE_IN,
    title: 'Enable Prompt Slide-in',
    description: 'Grab attention with a popup that prompts visitors to take an action.',
    url: '',
    icon: '/assets/icons/funnel.svg',
    plan: PLANS.PRO.id,
    payload: UPGRADE_SLIDE_IN_PAYLOAD
  }
}

export const hasClassificationFeatures = (classification) => {
  if (!classification || !classification.category) {
    return false
  }

  const normalizedCategory = classification.category.toLowerCase().replace(/\s+/g, '_')
  const features = categoryFeatures[normalizedCategory] || []

  return features.length > 0
}

export const getClassificationFeatures = (classification) => {
  if (!classification || !classification.category) {
    return []
  }

  const normalizedCategory = classification.category.toLowerCase().replace(/\s+/g, '_')
  const featureIds = categoryFeatures[normalizedCategory] || []

  return featureIds
    .slice(0, 3)
    .map((featureId) => ({
      id: featureId,
      ...featureDetails[featureId]
    }))
    .filter((feature) => feature.title) // Filter out any undefined features
}

export const getRandomFeatures = (count = 2) => {
  const allFeatureIds = Object.values(FEATURE_IDS).filter((id) => id !== FEATURE_IDS.CUSTOM_DOMAIN)
  const shuffled = allFeatureIds.sort(() => 0.5 - Math.random())
  return shuffled
    .slice(0, count)
    .map((featureId) => ({
      id: featureId,
      ...featureDetails[featureId]
    }))
    .filter((feature) => feature.title)
}
